import React, { useState,useContext } from "react";
import { 
  Tabs, 
  Tab, 
  Box, 
  Typography,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  TextField,
  IconButton,
  Pagination,
  Skeleton,
  Chip,
  Tooltip
} from "@mui/material";
import { 
  Search,
  ArrowUpward,
  ArrowDownward,
  InfoOutlined
} from "@mui/icons-material";

import { styled } from '@mui/material/styles';
import AdminDashboard from "../AdminDashboard";
import CategoryContext from "../context/CategoryContext";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1.5),
  fontSize: '0.875rem',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&.MuiTableCell-head': {
    backgroundColor: theme.palette.grey[50],
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}));


const ProductCategory = () => {
  const { loading,category } = useContext(CategoryContext); // ✅ Access products from context
  const theme = useTheme();

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });



  const columns = [
    { id: 'ProductCatID', label: 'Category ID', sortable: true },
    { id: 'Name', label: 'Full Name', sortable: true },
  ];


  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const filteredData = category.filter(item =>
    item.Name && item.Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const paginatedData = sortedData.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <AdminDashboard>
      <Box sx={{ 
        backgroundColor: 'white', 
        borderRadius: 4,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        p: 3
      }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Product Category
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{lineHeight:"2"}}>
            Track and manage categories of the product.
          </Typography>
        </Box>

        <Paper sx={{ 
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden',
        }}>
 <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              
                     </Box>
                    <Box sx={{ 
                              p: 2, 
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              borderBottom: `1px solid ${theme.palette.divider}`
                            }}>

            <TextField
              variant="outlined"
              size="small"
              placeholder="Search earnings..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <Search fontSize="small" sx={{ mr: 1 }} />,
                sx: { borderRadius: 2, width: { xs: '100%', sm: 300 } }
              }}
              sx={{ mt: { xs: 2, sm: 0 } }}
            />
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell 
                      key={column.id}
                      onClick={() => column.sortable && handleSort(column.id)}
                      sx={{ 
                        cursor: column.sortable ? 'pointer' : 'default',
                        minWidth: 150,
                      }}
                    >
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        <span>{column.label}</span>
                        {sortConfig.key === column.id && (
                          sortConfig.direction === 'asc' ? 
                          <ArrowUpward fontSize="small" sx={{ fontSize: '0.75rem' }} /> : 
                          <ArrowDownward fontSize="small" sx={{ fontSize: '0.75rem' }} />
                        )}
                      </Stack>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  Array.from({ length: 5 }).map((_, index) => (
                    <TableRow key={index}>
                      {columns.map((_, i) => (
                        <StyledTableCell key={i}>
                          <Skeleton variant="text" width={120} />
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  paginatedData.map((row, index) => (
                    <TableRow hover key={row.ProductCatID} sx={{ 
                      backgroundColor: index % 2 === 0 ? 'inherit' : theme.palette.grey[50]
                    }}>
                      <StyledTableCell>{row.ProductCatID}</StyledTableCell>
                      <StyledTableCell>{row.Name ?? "N/A"}</StyledTableCell>

                     
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ 
            p: 2, 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            borderTop: `1px solid ${theme.palette.divider}`
          }}>
            <Typography variant="body2" color="text.secondary">
              Showing {paginatedData.length} of {filteredData.length} results
            </Typography>
            <Pagination
              count={Math.ceil(filteredData.length / rowsPerPage)}
              page={page}
              onChange={(_, value) => setPage(value)}
              color="primary"
              size="small"
              shape="rounded"
            />
          </Box>
        </Paper>
      </Box>
    </AdminDashboard>
  );
};

export default ProductCategory;